export default __webpack_public_path__ + "static/media/NorthernLights.630c0f5d.webp";